import { ArrowLeftOutlined } from '@ant-design/icons'
import Button, { ButtonProps } from './button'

export interface BackButtonProps
  extends Omit<ButtonProps, 'icon' | 'children'> {}

export const BackButton = (props: BackButtonProps): JSX.Element => (
  <>
    <Button {...props} icon={<ArrowLeftOutlined />} />
  </>
)
